<template>
  <div class="body-custom" v-loading="loading">
    <div class="card card-custom card-stretch gutter-b">
      <div class="card-header">
        <div class="card-title">
          <span class="card-icon">
            <i class="flaticon2-delivery-package text-primary"></i>
          </span>
          <h3 class="card-label"><b class="title-header">{{ BusinessTitle }}</b></h3>
        </div>
      </div>
      <div class="card-body">
        <el-form ref="ruleForm" :model="form" class="form-base">
          <div class="row mb-8">
            <div class="col-md-2">
              <label class="el-form-item__label form-item-start-template">お知らせタイトル</label>
            </div>
            <div class="col-md-3">
              <el-form-item class="mb-0" prop="oshirase_title">
                <el-input class="bg-gray-item" maxlength="32" placeholder="" v-model="form.oshirase_title"></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="row mb-8">
            <div class="col-md-2">
              <label class="el-form-item__label form-item-start-template">お知らせ内容</label>
            </div>
            <div class="col-md-6">
              <el-form-item class="mb-0" prop="oshirase_contents">
                <el-input class="bg-gray-item" maxlength="300" type="textarea" placeholder=""
                  v-model="form.oshirase_contents">
                </el-input>
              </el-form-item>
            </div>
          </div>

          <div class="row mb-8">
            <div class="col-md-2">
              <label class="el-form-item__label form-item-start-template">ファイル添付</label>
            </div>
            <div class="col-md-6">
              <div class="box-upload border">
                <div class="banner-item" >
                  <input :disabled="isUploadChunk" type="file" :v-model.lazy="files" id="file-name" @change="uploadFile()" style="display:none"/>
                  <label for="file-name" class="file-drag">
                      <div class="start">
                          <div><span class="file-upload-btn btn btn-primary">ファイル添付</span>
                              <span class="ml-4">{{ form.file_name }}</span>
                          </div>
                      </div>
                  </label>
                </div>

                <div v-show="isUploadChunk" class="upload-chunk-progress">
                    <div class="progress-bar progress-bar-striped bg-success"  :style="`width: ${uploadChunkProgress}%`">{{ uploadChunkProgress }}%</div>
                </div>
              </div>
              <p class="el-form-item__error ml-1r" v-if="isShowMsg">{{ errorFileMsg }}</p>
            </div>
          </div>

          <div class="row mb-8">
            <div class="col-md-2">
              <label class="el-form-item__label form-item-start-template">表示フラグ</label>
            </div>
            <div class="col-md-3">
              <el-form-item class="mb-0" prop="oshirase_show_flag">
                <el-radio v-model="form.oshirase_show_flag" label="1">表示</el-radio>
                <el-radio v-model="form.oshirase_show_flag" label="0">非表示</el-radio>
              </el-form-item>
            </div>
          </div>

          <div class="row mb-8">
            <div class="col-md-5">
              <el-button 
                type="primary" 
                @click="submitForm()"
                :disabled="uploadChunkProgress > 0"
              >登録</el-button>
            </div>
          </div>
          <input type="hidden" name="_csrf" v-model="form._csrf" />
        </el-form>
      </div>
    </div>
  </div>

</template>

<script>
import apiService from "@/core/services/api.service";
import { mapActions, mapGetters } from 'vuex';
import { SET_TITLE_BUSINESS } from "@/core/services/store/business.module";
import { SUCCESS_MESSAGE } from "@/core/config/constant";
import { getCsrfRandom } from "@/core/services/store/auth.module";
import { UPLOAD_CHUNKS } from "@/core/services/store/upload.module";


export default {
  name: "create",
  data() {
    return {
      image: {},
      files: [],
      form: {
        oshirase_title: '',
        oshirase_show_flag: '1',
        oshirase_contents: '',
        file_name: '',
        file_new:true,
        file_path: '',
        _csrf:''
      },
      loading: false,
      isSubmit: false,
      isShowMsg: false,
      errorFileMsg: "",
    };
  },
  async created() {
    this.loading = true;
    if (this.BusinessTitle == null) {
      await this.setTitleBusiness()
    }
    this.form._csrf = getCsrfRandom()
    this.loading = false;
  },
  computed: {
    ...mapGetters(["BusinessStatus", "BusinessErrors", "BusinessTitle", "getUploadChunksProgress"]),

    uploadChunkProgress(){ return parseFloat(this.getUploadChunksProgress)},
    isUploadChunk(){
        const progress = parseFloat(this.getUploadChunksProgress)
        return progress < 100 && progress > 0
    }
  },
  methods: {
    ...mapActions([SET_TITLE_BUSINESS, UPLOAD_CHUNKS]),
    
    async uploadFile() {
      try{
        this.isShowMsg = false
        this.isSubmit = true;
        const uploadRes = await this[UPLOAD_CHUNKS]( {file: event.currentTarget.files[0], type_upload : "notification"})
        this.image[`${name}`] = uploadRes.data.file_name
        this.form.file_name = uploadRes.data.file_name;
        this.isSubmit = false;
      } catch(e) {
        this.errorFileMsg = e.message
        this.isShowMsg = true
        this.isSubmit = false;
      }

    },
    submitForm() {
      if( this.getUploadChunksProgress > 0){
        console.warn(`=== upload is processing`)
        return;
      }
      this.isSubmit = true
      this.$refs["ruleForm"].clearValidate()
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          const formData = new FormData();
          formData.append('oshirase_title', this.form.oshirase_title);
          formData.append('oshirase_contents', this.form.oshirase_contents);
          formData.append('oshirase_show_flag', this.form.oshirase_show_flag);
          formData.append('file_name', this.form.file_name);
          formData.append('file_new', this.form.file_new);
          formData.append('file_path', this.form.file_path);
          formData.append('_csrf', this.form._csrf);
          this.loading = true;
          const headers = { 'Content-Type': 'multipart/form-data' };
          apiService.post(`notification/add`, formData, headers).then(async (data) => {
              if (data && data.data && data.data.success) {
                this.notifySuccess(SUCCESS_MESSAGE)
                this.form = {
                  oshirase_title: '',
                  oshirase_show_flag: '1',
                  oshirase_contents: '',
                  file_name: '',
                  file_path: '',
                }
              } else {
                if (data.data.code == 422) {
                  this.showErrorMessage(data.data.data, 'ruleForm')
                } else if (data.data.code == 400) {
                  this.notifyError(data.data.message)
                } else {
                  this.notifyError('error server')
                }
              }
            }).catch(e => {
              this.loading = false
              this.notifyError(e)
            })
        } else {
          return false;
        }
      });
      this.loading = false
      this.isSubmit = false
    }
  }
}
</script>

<style scoped>
.ml-1r {
  margin-left: 1rem !important;
}

.box-upload.border {
    position: relative;
}
.upload-chunk-progress {
    position: absolute;
    width: 100%;
    margin-top: 10px;

    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    height: 1rem;
    overflow: hidden;
    line-height: 0;
    font-size: 0.75rem;
    background-color: #EBEDF3;
    border-radius: 0.42rem;
    -webkit-box-shadow: none;
    box-shadow: none;
    
    .progress-bar {
        background-repeat: repeat-x;
    }
}
</style>
